// export const MAIN_BASE =  'http://172.10.40.167:8080/';
// export const MAIN_BASE = "https://chat.onlinetelekom.net/";
// export const API_BASE = MAIN_BASE + "api/api";

export const MAIN_BASE = "https://hbk.btsyazilim.com/";
export const API_BASE = MAIN_BASE + "api/api";